<script>
    export default {
        props: {
            wrap: {
                type: String,
                required: false,
            },
            reverse: {
                type: Boolean,
                required: false,
            },
        },
        data() {
            return {
                classes: 'form__row',
            };
        },
        created() {
            if (this.wrap) {
                this.classes += ' form__row--no-wrap';
            }
            if (this.reverse) {
                this.classes += ' reverse__form-row';
            }
        },
    };
</script>

<template>
    <div :class="classes">
        <slot></slot>
    </div>
</template>
